import { nanoid } from 'nanoid';

/** Stable id generator for sections/blocks. */
export function generateId(type = 'node') {
  return `${type}_${nanoid(8)}`;
}
